import { getBeneficiaryInitials, getBeneficiaryLogoColor, getBeneficiaryLogoTextColor } from "@/modules/beneficiary/helpers";

interface Props {
  name: string;
}

export const BeneficiaryLogo = ({ name }: Props) => {
  const initials = getBeneficiaryInitials(name);
  const backgroundColor = getBeneficiaryLogoColor(name);
  const color = getBeneficiaryLogoTextColor(name);

  return (
    <div className="beneficiary-logo" style={{ backgroundColor, color }}>
      {initials}
    </div>
  );
};
